<app-header [title]="project()?.name || 'Project'"
            [description]="project()?.topic || 'Manage your project settings'">
</app-header>
@if (loading()) {
  <app-loading-card title="Loading your summaries...">
    <p>insights, taming wild data points, and convincing AI to share its wisdom. Your summaries are almost ready!</p>
  </app-loading-card>
}
<section>
  @if (summaries(); as summaries) {
    @if (summaries.length == 0) {
      @if (editable()) {
        <div class="whats-next">
          <app-empty-state
            title="Start your first analysis"
            subtitle="You can specify which paper you would like to use, the tone and the length of the summary."
            primaryButtonLabel="Start Analysis"
            icon="not_started"
            [primaryButtonEnabled]="true"
            (cta)="createSummary()"
          ></app-empty-state>
        </div>
      } @else {
        <div class="whats-next">
          <app-empty-state
            title="No analysis was created"
            subtitle="The creator of this project can create one."
            icon="not_started"
          ></app-empty-state>
        </div>
      }
    } @else {
      <mat-toolbar>
        <h1>Your Analysis (Beta)</h1>
        @if (editable()) {
          <span class="spacer"></span>

          @if (summaryProcessRunning()) {
            <button mat-flat-button
                    class="stop-summary-btn"
                    (click)="stopSummaryProcess()"
                    aria-label="Stop summary process">
              <mat-icon>book_4_spark</mat-icon>
              <span>Stop analysing</span>
            </button>
          } @else {
            <button mat-raised-button
                    aria-label="Join new Project"
                    (click)="createSummary()"
            >
              <mat-icon>add</mat-icon>
              <span>Add Analysis</span>
            </button>
          }
        }
      </mat-toolbar>

      <table mat-table [dataSource]="summaries" class="mat-elevation-z8">

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name</th>
          <td mat-cell *matCellDef="let summary">
            <a [routerLink]="[summary.id]">
              {{ summary.name }}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="topic">
          <th mat-header-cell *matHeaderCellDef> Setting</th>
          <td mat-cell *matCellDef="let summary" class="summary-setting">
            <span><strong>Tone: </strong>{{ summary.tone }}</span>
            <span><strong>Length: </strong>{{ summary.length }}</span>
            <span><strong>Accuracy: </strong>{{ summary.accuracy }}</span>
          </td>
        </ng-container>


        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
          <td mat-cell *matCellDef="let project">
            <button mat-icon-button [matMenuTriggerFor]="projectTableMenu"
                    [matMenuTriggerData]="{project: project}"
                    aria-label="Context Menu for each project">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    }
  } @else {
    <div class="whats-next">
      <app-empty-state
        title="Start your first analysis"
        subtitle="You can specify which paper you would like to use, the tone and the length of the summary."
        primaryButtonLabel="Start Analysis"
        [primaryButtonEnabled]="true"
        icon="not_started"
        (cta)="createSummary()"
      ></app-empty-state>
    </div>
  }
  <mat-menu #projectTableMenu="matMenu">
    <ng-template matMenuContent let-project="project">
      <button mat-menu-item (click)="deleteSummary(project)">
        <mat-icon>delete</mat-icon>
        <span>Delete</span>
      </button>
    </ng-template>
  </mat-menu>
</section>
